export type AppEnv = 'production' | 'staging' | 'development';

export const APP_ENV: AppEnv = (import.meta.env.VITE_APP_ENV as AppEnv) || 'development';

export const PDF_API_BASE_URL: string = import.meta.env.VITE_PDF_API_BASE_URL || '';

export const WAREHOUSE_APP_URL: string = import.meta.env.VITE_WAREHOUSE_APP_URL || 'http://localhost:5175';

export const EDI_APP_URL: string = import.meta.env.VITE_EDI_APP_URL || 'http://localhost:5174';
